import { useLayoutEffect, useRef, createRef } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import gsap from 'gsap'
import BtnLink from '@/components/BtnLink'
import SimpleSplitText from '@/components/SimpleSplitText'
import style from './style'

const useStyles = createUseStyles(style)

const TextSlide = ({
  backLink,
  backLinkLabel,
  color,
  commaTitle,
  ctaLabel,
  delay,
  inView,
  link,
  parallax,
  pretitle,
  title,
}) => {
  const classes = useStyles()
  const $root = useRef()
  const $pretitle = useRef()
  const $backLink = useRef()
  const $titles = useRef(title?.map(() => createRef()))
  const $cta = useRef()
  const history = useHistory()

  const enter = () => {
    const timeline = gsap.timeline({ ease: 'power3.out' })
    if ($pretitle.current) {
      timeline.to($pretitle.current, {
        opacity: 1,
        delay: 1,
      })
    }
    if ($backLink.current) {
      timeline.to($backLink.current, {
        opacity: 1,
      })
    }
    $titles.current.map((t) => t.current.appear())
    if ($cta.current) {
      timeline.to($cta.current, {
        delay: 2,
        opacity: 1,
      })
    }
  }

  useLayoutEffect(() => {
    if (inView) enter()
  }, [inView])

  return (
    <div className={classes.root} ref={$root}>
      {backLink && (
        <div
          ref={$backLink}
          className={classes.backLink}
        >
          <button
            onClick={() => history.goBack()}
            ariaLabel="Back"
          >
            <span>&lt;</span>
            {' '}
            {backLinkLabel}
          </button>
        </div>
      )}
      {pretitle && (
        <div
          ref={$pretitle}
          className={classes.pretitle}
          dangerouslySetInnerHTML={{ __html: pretitle }}
        />
      )}
      <div
        {...{ // eslint-disable-line
          ...(parallax && {
            'data-scroll': true,
            'data-scroll-speed': 2,
          }),
        }}
        className={classNames({
          [classes.cream]: color === 'cream',
        })}
      >
        {title?.map((t, i) => (
          <SimpleSplitText
            ref={$titles.current[i]}
            key={i} // eslint-disable-line react/no-array-index-key
            className={classNames({
              [classes.title]: true,
              TextSlide__title: true,
            })}
            text={`${t}${i === 0 && commaTitle ? ',' : ''}`}
            appear
            disableHover
            delay={delay + (i / 4)}
            animation="linear"
          />
        ))}
      </div>
      {link && (
        <div
          ref={$cta}
          className={classes.link}
        >
          <BtnLink
            label={ctaLabel}
            link={link}
            theme={color}
          />
        </div>
      )}
    </div>
  )
}

TextSlide.propTypes = {
  backLinkLabel: PropTypes.string,
  commaTitle: PropTypes.bool,
  parallax: PropTypes.bool,
  title: PropTypes.array.isRequired,
  inView: PropTypes.bool,
  delay: PropTypes.number,
}

TextSlide.defaultProps = {
  backLinkLabel: 'Back',
  commaTitle: false,
  parallax: false,
  inView: true,
  delay: 0,
}

export default TextSlide
